import { Component, Inject, OnInit } from '@angular/core';
import { SafetyGeneraldashboardService } from '../../services/safety-generaldashboard.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-add-comment-dialog',
  templateUrl: './add-comment-dialog.component.html',
  styleUrls: ['./add-comment-dialog.component.css']
})
export class AddCommentDialogComponent implements OnInit {

  constructor(public dialogRef:MatDialogRef<AddCommentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _safetyGeneraldashboardService: SafetyGeneraldashboardService) { }

    ActionObserved=this.data.ActionObserved;
    Responsibility=this.data.Responsibility;
    FollowUpActions=this.data.FollowUpActions
   
    
    QuestionName=this.data.QuestionName

  ngOnInit() {

    console.log("observation ID",this.data.ObservationQuestionId)
    console.log("QuestionName",this.data.QuestionName)
  }
  DialogClose(){
    this.dialogRef.close(false)
  }
  SaveQuestionComments()
  {
   this._safetyGeneraldashboardService.SaveQuestionComments(this.data.ObservationQuestionId,this.ActionObserved, this.Responsibility, this.FollowUpActions).subscribe(r=>{   
   });
   this. DialogClose()
  }
}
